import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {BillingService} from '../../service/billing/billingService.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ProductGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var productGrid = this;
		setTimeout(function(){
			productGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var productGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PRODUCTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PRODUCTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'updateStatus',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PRODUCTS:UPDATE_STATUS'],
					style: 'float: right;',
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionUpdateStatus(grid.selectedItems[0]);
						}
					}
				}		
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'productCode',
					header: 'Product Code',					
					width: '7em'
				},
				{						
					path: 'productName',
					header: 'Name',					
					width: '9em'
				},
				{						
					path: 'productDesc',
					header: 'Decription',					
					'flex-grow': '1'					
				},
				{						
					path: 'productTypeDescription',
					header: 'Type',					
					width: '7em'
				},
				{						
					path: 'productEffDate',
					header: 'Effective Date',						
					width: '9em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {											
						root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.productEffDate);
					}
				},
				{						
					path: 'productCancelDate',
					header: 'Cancel Date',						
					width: '9em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {											
						root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.productCancelDate);
					}
				},
				{						
					path: 'proratePriceFlag',
					header: 'Prorate',					
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'billingFactorTypeDescription',
					header: 'Factoring Type',					
					width: '7em'
				},
				{
					path: 'applicationModule',
					header: 'App Module',
					width: '9em'
				},
				{
					path: 'defaultBillingCycleDay',
					header: 'Default Bill Day',
					'text-align': 'center',
					width: '8em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {							
						ElementUtil.enableDisableAction(toolbar, 'edit', false);
						ElementUtil.enableDisableAction(toolbar, 'updateStatus', false);
					} else {						
						ElementUtil.enableDisableAction(toolbar, 'edit', true);
						ElementUtil.enableDisableAction(toolbar, 'updateStatus', true);
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					productGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value						
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						productGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getProductService().getProducts(productGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'products',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'products.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		productGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(product) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Product',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
												
							var productItems = [];
							var productItemGrid = ElementUtil.create({
								tag: 'vaadin-grid',
								theme: 'row-stripes column-borders',
								'column-reordering-allowed': '',
								style: 'height: 100%;',
								slot: 'primary',
								defaults: {
									tag: 'vaadin-grid-sort-column',
									resizable: true				
								},			
								children: [	
									{						
										path: 'itemSeqNo',
										header: 'Sequence',					
										width: '5em',
										'text-align': 'end'
									},
									{
										path: 'billingTypeDescription',
										header: 'Billing Type',					
										width: '9em'
									},
									{						
										path: 'productItemPK.featureProductCode',
										header: 'Feature Code',					
										width: '7em',
										renderer: function(root, column, rowData) {
											root.innerHTML = rowData.item.productItemPK.featureProductCode;
										}
									},									
									{						
										path: 'itemDesc',
										header: 'Description',					
										'flex-grow': '1'
									},
									{
										path: 'itemEffDate',
										header: 'Effective Date',					
										width: '9em',
										renderer: function(root, column, rowData) {											
											root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.itemEffDate);
										}
									},
									{
										path: 'itemCancelDate',
										header: 'Cancel Date',					
										width: '9em',
										renderer: function(root, column, rowData) {		
											if (rowData.item.itemCancelDate) {
												root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.itemCancelDate);
											}
										}
									},
									{
										path: 'billableFlag',
										header: 'Billable',					
										width: '9em',
										'text-align': 'center',
										renderer: function(root, column, rowData) {
											root.innerHTML = rowData.item.billableFlag ? true : false;
										}
									},
									{
										path: 'otherFeesTypeDescription',
										header: 'Other Fee Type',					
										width: '9em'
									}
								],
								listeners: {
									'active-item-changed': function(event) {
										const item = event.detail.value;
										productItemGrid.selectedItems = item ? [item] : [];
										if (productItemGrid.selectedItems.length > 0) {											
											ElementUtil.query(formPanel, 'editItem').disabled = false;
											if (item.new) {
												ElementUtil.query(formPanel, 'removeItem').disabled = false;
											}
										} else {	
											ElementUtil.query(formPanel, 'editItem').disabled = true;										
											ElementUtil.query(formPanel, 'removeItem').disabled = true;
										}	
									}
								}
							});					
						
							var permissions = [];
							var permissionMap = {};
							var permissionGrid = ElementUtil.create({
								tag: 'vaadin-grid',
								theme: 'row-stripes column-borders',
								'column-reordering-allowed': '',
								style: 'height: 100%;',
								slot: 'primary',
								defaults: {
									tag: 'vaadin-grid-sort-column',
									resizable: true				
								},			
								children: [	
									{						
										path: 'permissionCode',
										header: 'Code',					
										width: '9em'
									},
									{
										path: 'permissionCodeDescription',
										header: 'Description',					
										width: '9em'										
									}
								],
								listeners: {
									'active-item-changed': function(event) {
										const item = event.detail.value;
										permissionGrid.selectedItems = item ? [item] : [];
										if (permissionGrid.selectedItems.length > 0) {																
											ElementUtil.query(formPanel, 'removePermission').disabled = false;
										} else {																
											ElementUtil.query(formPanel, 'removePermission').disabled = true;
										}	
									}
								}
							});							
						
							var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Code',
											name: 'productCode',
											required: true,
											maxlength: 80
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Name',
											name: 'productName',											
											required: true,
											maxlength: 255																						
										},
										{
											tag: 'vaadin-text-field',
											label: 'Description',
											name: 'productDesc',											
											required: true,
											maxlength: 255																						
										},
										{
											tag: 'vaadin-combo-box',									
											label: 'Product Type', 
											itemId: 'productType',
											name: 'productType',
											'item-value-path': 'code',
											'item-label-path': 'description',									
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('ProductType').then(function(data){
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-date-picker',
											label: 'Effective Date',
											name: 'productEffDate',
											required: true
										},
										{
											tag: 'vaadin-date-picker',
											label: 'Cancel Date',
											name: 'productCancelDate'
										},
										{										
											tag: 'vaadin-checkbox',									
											name: 'proratePriceFlag',
											label: 'Prorate Price'										
										},
										{
											tag: 'vaadin-combo-box',									
											label: 'Factoring Type', 
											name: 'billingFactorType',
											'item-value-path': 'code',
											'item-label-path': 'description',										
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('BillingFactorType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'appModule',
											label: 'Application Module',
											name: 'applicationModule',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											postinit: function(combo) {
												Service.getApplicationModuleService().getModules({status: 'A'}).then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Default Bill Day',
											name: 'defaultBillingCycleDay',
											'item-value-path': 'code',
											'item-label-path': 'description',
											clearButtonVisible: true,
											postinit: function(combo) {
												var data = [];
												for (var i = 1; i < 29; i++) {
													data.push({
														code: '' + i,
														description: i
													});
												}
												combo.items = data;
											}
										},
										{
											tag: 'dl-section-title',
											title: 'Product Items',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'height: 250px',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'addItem',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditProduct();
																		}
																	}					
																},	
																{
																	tag: 'vaadin-button',
																	itemid: 'editItem',																	
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditProduct(productItemGrid.selectedItems[0]);
																		}
																	}					
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeItem',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveProduct(productItemGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														productItemGrid													
													]
												}
											]										
										},
										{
											tag: 'dl-section-title',
											title: 'Permissions',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'height: 300px',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'addPermission',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddPermission();
																		}
																	}					
																},																	
																{
																	tag: 'vaadin-button',
																	itemid: 'removePermission',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemovePermission(permissionGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														permissionGrid													
													]
												}
											]	
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																	//data.country = ElementUtil.query(formPanel, 'state').selectedItem.country;																	
																	
																	if (data.billingFactorType === '') {
																		delete data.billingFactorType;
																	}
																	if (data.applicationModule === '') {
																		delete data.applicationModule;
																	}
																	if (data.defaultBillingCycleDay === '' || data.defaultBillingCycleDay == null) {
																		data.defaultBillingCycleDay = null;
																	} else {
																		data.defaultBillingCycleDay = parseInt(data.defaultBillingCycleDay, 10);
																	}
																	
																	var fullProductModel = {
																		product: data,
																		fullProductItems: [],
																		permissions: []
																	};																				
																																	
																	productItems.forEach(function(item){
																		
																		var fullItem = {
																			productItem: item,
																			productItemPrices: []
																		};
																		fullItem.productItem.productItemPK.productCode = data.productCode;
																		
																		item.prices.forEach(function(price){
																			price.featureProductCode = item.featureProductCode;
																			price.productCode = data.productCode;
																			fullItem.productItemPrices.push(price);	
																		});																
																		fullProductModel.fullProductItems.push(fullItem);
																	});
																	
																	permissions.forEach(function(permission){		
																		permission.actions = permission.actions ? permission.actions : [];
																		permission.actions.forEach(function(action){
																			fullProductModel.permissions.push({
																				productSecurityPermissionPK: {
																					productCode: data.productCode,
																					permissionCode: permission.permissionCode,
																					permissionAction: action
																				}																				
																			});
																		});																																				
																	});																																																			
																	
																	return fullProductModel;
																},
																actualCall: function(data) {																
																	return BillingService.getProductService().saveProduct(data, product ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Product', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (product) {														
							//load details ...unpack							
							var loadMask = formPanel.showLoading();
							BillingService.getProductService().getProductDetails(product.productCode).then(function(detail){
								loadMask.remove();

								if (detail.product.defaultBillingCycleDay != null) {
									detail.product.defaultBillingCycleDay = '' + detail.product.defaultBillingCycleDay;
								}
								formPanel.load(detail.product);
													
								setTimeout(function(){
									ElementUtil.query(formPanel, 'appModule').focus();
									ElementUtil.query(formPanel, 'appModule').blur();
									
									ElementUtil.query(formPanel, 'productType').focus();
									ElementUtil.query(formPanel, 'productType').blur();									
								}, 500);								
								
								detail.fullProductItems.forEach(function(item){
									var existingItem = item.productItem;
									existingItem.prices = item.productItemPrices;
									productItems.push(existingItem);
								});
								actionRefreshProducts();
								
								var permissionMap = {};								
								detail.permissions.forEach(function(detailPermission){
									if (permissionMap[detailPermission.productSecurityPermissionPK.permissionCode]) {
										permissionMap[detailPermission.productSecurityPermissionPK.permissionCode].actions.push(detailPermission.productSecurityPermissionPK.permissionAction);
									} else {
										permissionMap[detailPermission.productSecurityPermissionPK.permissionCode] = {
											permissionCode: detailPermission.productSecurityPermissionPK.permissionCode,
											permissionCodeDescription: detailPermission.permissionCodeDescription,
											actions: [detailPermission.productSecurityPermissionPK.permissionAction]
										};
									}
									
								});
								for (var permissionCode in permissionMap) {
									permissions.push(permissionMap[permissionCode]);
								}
								actionRefreshPermissions();
								
							});
							
														
						}
						
						var actionAddEditProduct = function (productItem) {
							var addEditItemWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add/Edit Product Item',
								icon: 'lumo:edit',
								width: .65,
								height: .75,
								listeners: {
									ready: function () {
										addEditItemWin.show();

										var prices = [];
										var priceGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'itemQuantity',
													header: 'Quantity',
													width: '7em'
												},
												{
													path: 'productQuantityUom',
													header: 'Quantity UOM',
													width: '9em'
												},
												{
													path: 'itemPriceAmt',
													header: 'Price Amount',
													width: '9em',
													renderer: function(root, column, rowData) {
														root.innerHTML = StringUtil.currencyFormat(rowData.item.itemPriceAmt);
													}
												},
												{
													path: 'paymentOption',
													header: 'Payment Option',
													width: '9em'
												},
												{
													path: 'priceEffDate',
													header: 'Effective Date',
													width: '9em',
													renderer: function(root, column, rowData) {											
														root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.priceEffDate);
													}
												},
												{
													path: 'priceCancelDate',
													header: 'Cancel Date',
													width: '9em',
													renderer: function(root, column, rowData) {															
														root.innerHTML = TimeUtil.formatDateOnlyStandard(rowData.item.priceCancelDate);
													}
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													priceGrid.selectedItems = item ? [item] : [];
													if (priceGrid.selectedItems.length > 0) {
														ElementUtil.query(prodItemFormPanel, 'editPrice').disabled = false;

														if (item.new) {
															ElementUtil.query(prodItemFormPanel, 'removePrice').disabled = false;
														} else {
															ElementUtil.query(prodItemFormPanel, 'removePrice').disabled = true;
														}
													} else {
														ElementUtil.query(prodItemFormPanel, 'editPrice').disabled = true;
														ElementUtil.query(prodItemFormPanel, 'removePrice').disabled = true;
													}
												}
											}
										});

										var prodItemFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															itemid: 'billingType',
															label: 'Billing Type',
															name: 'billingType',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('BillingType').then(function (data) {
																	combo.items = data;
																});
															}
														},
														{
															tag: 'vaadin-number-field',
															label: 'Sequence',
															name: 'itemSeqNo',
															required: true,
															min: -9999,
															max: 9999
														},														
														{
															tag: 'vaadin-combo-box',
															label: 'Feature Code',
															name: 'featureProductCode',
															'item-value-path': 'productCode',
															'item-label-path': 'productName',
															required: true,
															postinit: function (combo) {
																BillingService.getProductService().getProducts().then(function(products){
																	combo.items = products.data;	
																});
															}
														},
														{
															tag: 'vaadin-text-field',
															label: 'Description',
															name: 'itemDesc',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-date-picker',
															label: 'Effective Date',
															name: 'itemEffDate',
															required: true
														},
														{
															tag: 'vaadin-date-picker',
															label: 'Cancel Date',
															name: 'itemCancelDate'
														},
														{
															tag: 'vaadin-checkbox',
															name: 'billableFlag',
															checked: true,
															label: 'Billable'
														},														
														{
															tag: 'vaadin-combo-box',
															itemid: 'otherFeesType',
															label: 'Other Fees Type',
															name: 'otherFeesType',
															'item-value-path': 'code',
															'item-label-path': 'description',															
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('OtherFeesType').then(function (data) {
																	combo.items = data;
																});
															}
														},																												
														{
															tag: 'dl-section-title',
															title: 'Prices',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'height: 250px',
															colspan: 2,
															children: [
																{
																	tag: 'dl-flex-layout',
																	children: [
																		{
																			tag: 'dl-toolbar',
																			slot: 'toolbar',
																			theme: 'spacing',
																			children: [
																				{
																					tag: 'vaadin-button',
																					itemid: 'addPrice',
																					theme: 'primary',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:plus', ' Add')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditPrice();
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'editPrice',
																					'class': 'spacer-toolbar-item',
																					children: [
																						ElementUtil.makeIcon('vaadin:edit', ' Edit')
																					],
																					listeners: {
																						click: function () {
																							actionAddEditPrice(priceGrid.selectedItems[0]);
																						}
																					}
																				},
																				{
																					tag: 'vaadin-button',
																					itemid: 'removePrice',
																					theme: 'error primary',
																					'class': 'spacer-toolbar-item',
																					style: 'float: right;',
																					children: [
																						ElementUtil.makeIcon('vaadin:close', ' Remove')
																					],
																					listeners: {
																						click: function () {
																							actionRemovePrice(priceGrid.selectedItems[0]);
																						}
																					}
																				}
																			]
																		},
																		priceGrid
																	]
																}
															]
														},														
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function () {																			
																																				
																			var data = prodItemFormPanel.getData();	
																			
																			//need at least 1 price
																			if (prices.length < 1) {
																				window.DL.MessageUtil.showOkMessage("Must have at least one price.");
																			} else {
																				//add prices
																				data.prices = prices;
																				
																				var selectedBillingType = ElementUtil.query(prodItemFormPanel, 'billingType').selectedItem;
																				var selectedOtherFeesType = ElementUtil.query(prodItemFormPanel, 'otherFeesType').selectedItem;
																				
																				if (productItem) {																																																	
																					
																					productItem.billingType = data.billingType;
																					productItem.billingTypeDescription = selectedBillingType.description;
																					
																					productItem.itemSeqNo = data.itemSeqNo;
																					productItem.productItemPK = {};
																					productItem.productItemPK.featureProductCode = data.featureProductCode;
																					productItem.itemDesc = data.itemDesc;
																					productItem.itemEffDate = data.itemEffDate;
																					productItem.itemCancelDate = data.itemCancelDate;
																					productItem.billableFlag = data.billableFlag;
																					productItem.prices = prices;
																																										
																					productItem.otherFeesType = data.otherFeesType;
																					if (selectedOtherFeesType) {
																						productItem.otherFeesTypeDescription = selectedOtherFeesType.description;
																					}																					
																				} else {
																					data.id = ElementUtil.nextId();
																					data.new = true;
																					data.productItemPK = {};
																					data.productItemPK.featureProductCode = data.featureProductCode;																					
																					
																					data.billingTypeDescription = selectedBillingType.description;
																					if (selectedOtherFeesType) {
																						data.otherFeesTypeDescription = selectedOtherFeesType.description;
																					}
																					
																					productItems.push(data);
																				}																							
																				actionRefreshProducts();
																				addEditItemWin.close();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditItemWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addEditItemWin.addToContentElement(prodItemFormPanel);

										var actionRefreshPrices = function() {																					
											priceGrid.activeItem = null;
											priceGrid.items = prices.slice(0);
										};

										if (productItem) {
											//load details ...unpack																		
											productItem.featureProductCode = productItem.productItemPK.featureProductCode;
											
											prodItemFormPanel.load(productItem);
											prices = productItem.prices ? productItem.prices : [];
											actionRefreshPrices();
										}
																				
										var actionAddEditPrice = function(price) {
											
											var addEditPriceWin = ElementUtil.create({
												tag: 'dl-dialog',
												title: 'Add/Edit Price',
												icon: 'lumo:edit',
												width: .55,
												height: 400,
												listeners: {
													ready: function () {
														addEditPriceWin.show();
														
														var priceFormPanel = ElementUtil.create({
															tag: 'dl-form-panel',
															itemid: 'form',
															children: [
																{
																	tag: 'vaadin-form-layout',
																	children: [																		
																		{
																			tag: 'vaadin-number-field',
																			label: 'Price',
																			name: 'itemPriceAmt',
																			required: true,
																			min: -9999999,
																			max: 9999999
																		},
																		{
																			tag: 'vaadin-number-field',
																			label: 'Quantity',
																			name: 'itemQuantity',
																			required: true,
																			value: 1,
																			min: -9999,
																			max: 9999
																		},
																		{
																			tag: 'vaadin-combo-box',
																			label: 'Quantity UOM',
																			name: 'productQuantityUom',
																			'item-value-path': 'code',
																			'item-label-path': 'description',
																			value: 'EA',																			
																			postinit: function (combo) {
																				Service.getLookupService().getLookupValues('ProductQuantityUom').then(function (data) {
																					combo.items = data;
																					combo.required = true;
																				});
																			}
																		},
																		{
																			tag: 'vaadin-combo-box',
																			label: 'Payment Option',
																			name: 'paymentOption',
																			'item-value-path': 'code',
																			'item-label-path': 'description',
																			value: 'MONTHLY',																			
																			postinit: function (combo) {
																				Service.getLookupService().getLookupValues('PaymentOption').then(function (data) {
																					combo.items = data;
																					combo.required = true;
																				});
																			}
																		},																		
																		{
																			tag: 'vaadin-date-picker',
																			label: 'Effective Date',
																			name: 'priceEffDate',
																			required: true
																		},
																		{
																			tag: 'vaadin-date-picker',
																			label: 'Cancel Date',
																			name: 'priceCancelDate'
																		},																															
																		{
																			tag: 'hr',
																			colspan: 2
																		},
																		{
																			tag: 'div',
																			style: 'text-align: center;',
																			colspan: 2,
																			defaults: {
																				tag: 'vaadin-button'
																			},
																			children: [
																				{
																					theme: 'primary',
																					children: [
																						ElementUtil.makeIcon('vaadin:database', ' Save')
																					],
																					listeners: {
																						click: function () {
																							
																							var data = priceFormPanel.getData();																							
																							if (price) {																																																	
																								price.itemPriceAmt = data.itemPriceAmt;
																								price.itemQuantity = data.itemQuantity;
																								price.productQuantityUom = data.productQuantityUom;
																								price.paymentOption = data.paymentOption;
																								price.priceEffDate = data.priceEffDate;
																								price.priceCancelDate = data.priceCancelDate;																								
																							} else {
																								data.id = ElementUtil.nextId();
																								data.currencyCode = 'USD';
																								data.new = true;
																								prices.push(data);
																							}																							
																							actionRefreshPrices();
																							addEditPriceWin.close();
																						}
																					}
																				},
																				{
																					theme: 'tertiary',
																					innerHTML: 'Cancel',
																					style: 'margin-left: 10px;',
																					listeners: {
																						click: function () {
																							//cancel
																							addEditPriceWin.close();
																						}
																					}
																				}
																			]
																		}
																	]
																}
															]

														});
														addEditPriceWin.addToContentElement(priceFormPanel);
														
														if (price) {
															priceFormPanel.load(price);
														}
														
													}
												}
											});	
											
										};
											
										var actionRemovePrice = function(priceRecord) {
											var newPrices = [];
											if (priceRecord.new) {
												prices.forEach(function(item){
													if (!(item.id === priceRecord.id)) {
														newPrices.push(item);
													}
												});	
												prices = newPrices;
												actionRefreshPrices();
											} else {
												console.log('Can only remove new prices.');
											}
										};	
											
									}
								}
							});

						};
						
						var actionRefreshProducts = function() {
							productItemGrid.activeItem = null;
							productItemGrid.items = productItems.slice(0);
						};
						
						var actionRemoveProduct = function(productItem) {
							var newItems = [];
							if (productItem.new) {
								productItems.forEach(function(item){
									if (!(item.productItemPK.productCode === productItem.productItemPK.productCode &&
										item.productItemPK.featureProductCode === productItem.productItemPK.featureProductCode)) {
										newItems.push(item);
									}
								});	
								productItems = newItems;
								actionRefreshProducts();
							} else {
								console.log('Can only remove new product items');
							}
						};
												
						
						var actionAddPermission = function() {
							var addPermissionWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Permission',
								icon: 'vaadin:plus',
								width: 400,
								height: 150,
								listeners: {
									ready: function () {
										addPermissionWin.show();

										var permissionForm = ElementUtil.create({
											tag: 'dl-form-panel',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															itemid: 'permissionCB',
															name: 'permission',
															label: 'Permission',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function (combo) {
																
																Service.getLookupService().getLookupValues('SecurityPermission').then(function(data){
																	var available = [];

																	//remove existing permissions
																	data.forEach(function (item) {
																		if (!permissionMap[item.code]) {
																			available.push(item);
																		}
																	});

																	combo.items = available;
																});
															},
															placeHolder: 'Select',
															listeners: {
																change: function () {
																	actionRefresh();
																}
															}
														}
													]
												},
												{
													tag: 'hr'
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:plus', ' Add')
															],
															listeners: {
																click: function () {
																	//add permission
																	if (permissionForm.isValid()) {
																		var permission = ElementUtil.query(permissionForm, 'permissionCB').selectedItem;
																		permissionMap[permission.code] = {
																			description: permission.description,
																			actions: {},
																			availableActions: permission.availableActions
																		};
																		permissions.push({
																			permissionCode: permission.code,
																			permissionCodeDescription: permission.description,
																			actions: permission.availableActions
																		});
																		
																		actionRefreshPermissions();
																		addPermissionWin.close();
																	}
																}
															}
														},
														{
															theme: 'tertiary',
															innerHTML: 'Cancel',
															style: 'margin-left: 10px;',
															listeners: {
																click: function () {
																	addPermissionWin.close();
																}
															}
														}
													]
												}
											]
										});
										addPermissionWin.addToContentElement(permissionForm);
									}
								}
							});							
							
						};
						
						var actionRefreshPermissions = function() {
							permissionGrid.activeItem = null;
							permissionGrid.items = permissions.slice(0);
						};
						
						var actionRemovePermission = function(permission) {
							var newPerms = [];
							permissions.forEach(function(item){
								if (!(item.permissionCode === permission.permissionCode)) {
									newPerms.push(item);
								}
							});	
							permissions = newPerms;
							actionRefreshPermissions();
						};
						
					}
				}
			});
		
						
		};

		var actionUpdateStatus = function(record) {
			var loadMask = grid.showLoading('Updating...');		
			BillingService.getProductService().updateProductStatus(record.productCode, !(record.activeStatus === 'A')).then(function(){
					loadMask.remove();				
					actionRefresh();
				});
		};		
	

	}
	
};
customElements.define('dl-product-grid', ProductGrid);